// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding-bottom: 120px;
}

.container .container-camera {
    margin-top: 5%;
    border: Ridge 4px white;
    border-radius: 20px;
    padding: 15px 0 0 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 95%;
}

.container .logo {
    width: 60%;
    border-radius: 0;
    margin-top: 5%;
}


.container img {
    width: 100%;
    object-fit: cover;
    border-radius: 20px;
}

.container h1 {
    color: white;
    font-size: 1.5rem;
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: 12px;
    text-align: center;
    text-shadow: 0.05em 0.05em 0.05em orangered;
}

.container button {
    position: fixed;
    bottom: 3%;
    left: 50%;
    width: 95%;
    height: 80px;
    transform: translateX(-50%);
    background-color: white;
    color: black;
    padding: 10px 20px;
    border-radius: 20px;
    cursor: pointer;
    font-size: 1.7rem;
    font-weight: bold;
    z-index: 1000;
    text-shadow: 0.05em 0.05em 0.05em orangered;
    border: Ridge 8px orangered;
}

.container button:active {
    background-color: orangered;
    color: white;
}

.container h2 {
    color: white;
    font-size: 3rem;
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: 12px;
    text-align: center;
    text-shadow: 0.05em 0.05em 0.05em orangered;
    margin-top: 150px;
}`, "",{"version":3,"sources":["webpack://./src/pages/inicio/inicio.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,cAAc;AAClB;;;AAGA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,UAAU;IACV,SAAS;IACT,UAAU;IACV,YAAY;IACZ,2BAA2B;IAC3B,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,2CAA2C;IAC3C,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,2CAA2C;IAC3C,iBAAiB;AACrB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    padding-bottom: 120px;\n}\n\n.container .container-camera {\n    margin-top: 5%;\n    border: Ridge 4px white;\n    border-radius: 20px;\n    padding: 15px 0 0 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 95%;\n}\n\n.container .logo {\n    width: 60%;\n    border-radius: 0;\n    margin-top: 5%;\n}\n\n\n.container img {\n    width: 100%;\n    object-fit: cover;\n    border-radius: 20px;\n}\n\n.container h1 {\n    color: white;\n    font-size: 1.5rem;\n    font-weight: bold;\n    text-transform: uppercase;\n    margin-bottom: 12px;\n    text-align: center;\n    text-shadow: 0.05em 0.05em 0.05em orangered;\n}\n\n.container button {\n    position: fixed;\n    bottom: 3%;\n    left: 50%;\n    width: 95%;\n    height: 80px;\n    transform: translateX(-50%);\n    background-color: white;\n    color: black;\n    padding: 10px 20px;\n    border-radius: 20px;\n    cursor: pointer;\n    font-size: 1.7rem;\n    font-weight: bold;\n    z-index: 1000;\n    text-shadow: 0.05em 0.05em 0.05em orangered;\n    border: Ridge 8px orangered;\n}\n\n.container button:active {\n    background-color: orangered;\n    color: white;\n}\n\n.container h2 {\n    color: white;\n    font-size: 3rem;\n    font-weight: bold;\n    text-transform: uppercase;\n    margin-bottom: 12px;\n    text-align: center;\n    text-shadow: 0.05em 0.05em 0.05em orangered;\n    margin-top: 150px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
